import {
  BlueprintProvider,
  Box,
  Button,
  Container,
  ContainerProps,
} from '@hover/blueprint';
import React, { FC } from 'react';
import { Navbar } from '@hover/shared-components';
import { Link } from 'gatsby';
import { BOTTOM_ITEMS, LINK_DESKTOP, LINK_MOBILE } from '../../../constants';
import { Footer } from '../../common';
import Analytics from '../../common/layout/Analytics';
import Logo from '../../common/navbar/Logo';
import { SEO } from '../../../../components/Seo';
import GlobalBanner from '../../common/layout/GlobalBanner';

interface Props extends ContainerProps {
  title: string;
  description?: string;
  titleColor?: string;
  ctaButton?: React.ReactElement;
  bannerElement?: React.ReactElement;
}

const LeadLayout: FC<Props> = ({
  children,
  title = '',
  description = '',
  titleColor,
  ctaButton,
  bannerElement,
  ...restProps
}) => {
  const renderBanner = () => {
    if (bannerElement) return bannerElement;
    return <GlobalBanner />;
  };

  return (
    <BlueprintProvider resetCSS includeFonts newTypography>
      <Analytics />
      <SEO
        title={title}
        description={description}
        additionalMetadata={[]}
        noIndex
      />
      {renderBanner()}
      <Box display="block" style={{ contain: 'content' }}>
        <Navbar
          showDivider
          dividerColor="primary.100"
          linksDesktop={[]}
          linksMobile={[]}
          isNavbarWhite
          navbarBackgroundColor="neutral.0"
          titleColor={titleColor}
          logo={<Logo isNavbarWhite titleColor={titleColor} />}
          ctaButton={
            ctaButton || (
              <Button to="/signup/" as={Link} fill="outline" size="large">
                CREATE AN ACCOUNT
              </Button>
            )
          }
        />
        <Container
          centerContent
          maxW="100%"
          px={0}
          pt={{ base: 900, desktop: 1000 }}
          {...restProps}
        >
          {children}
        </Container>
        <Footer
          linksDesktop={[...LINK_DESKTOP]}
          linksMobile={[...LINK_MOBILE]}
          footerBottomItems={BOTTOM_ITEMS}
        />
      </Box>
    </BlueprintProvider>
  );
};

export default LeadLayout;
